var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pa-0",attrs:{"color":"#fff"}},[_c('v-row',[_c('v-col',{staticClass:"text-center py-7",attrs:{"cols":"12"}},[_vm._v(" ©"+_vm._s(_vm.current_year)+" by JThink Co., Ltd. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }